import { Fragment } from 'react'
import { Link } from 'react-router'
import { PERMISSION_ACTION_VIEW, PERMISSION_ENTITY_SOURCE_DOCUMENT, ROUTE_DOCUMENT_REVIEW } from '@klear/constants'
import { useAuth } from '@klear/ui/contexts/auth-context'
import { trpc } from '@klear/ui/lib/trpc'

export default function OrderEventReviews({ orderEventId }: { orderEventId: number }) {
  const { user } = useAuth()
  const canView = user?.hasPermission(PERMISSION_ENTITY_SOURCE_DOCUMENT, PERMISSION_ACTION_VIEW) ?? false
  const { data: reviews = [] } = trpc.documents.list.useQuery(
    { filedOn: { kind: 'order_event', id: orderEventId } },
    {
      enabled: canView,
      select: (list) =>
        list.rows.flatMap((row) =>
          row.latestRun === null ? [] : [{ id: row.latestRun.id, run: row.latestRun.run, name: row.document.name }]
        )
    }
  )

  if (reviews.length === 0) return null

  return (
    <div className="text-muted-foreground text-sm">
      {reviews.length === 1 ? 'Document review' : 'Document reviews'}{' '}
      {reviews.map((review, index) => (
        <Fragment key={review.id}>
          {index > 0 && ', '}
          <Link to={`/${ROUTE_DOCUMENT_REVIEW}/${review.id}`} className="underline">
            {review.name}
            {reviews.length > 1 && ` (run ${review.run})`}
          </Link>
        </Fragment>
      ))}
    </div>
  )
}
